//@ts-nocheck
import axios from "axios";

import { expireFn } from "../utils/tools";
import { axiosPolling } from "./polling";
// import CancelRequest from "./cancel-request.js";

// const cancelRequest = new CancelRequest();
const http = axios.create({
  timeout: 60000,
});

// init polling
axiosPolling(http);

// request拦截器
http.interceptors.request.use(
  (config) => {
    // cancelRequest.removePendingRequest(config); // 检查是否存在重复请求，若存在则取消已发的请求
    // cancelRequest.addPendingRequest(config, http); // 把当前请求添加到pendingRequest对象中
    // const auth = JSON.parse(localStorage.getItem("good-auth") || "{}");
    // const expired = auth.token && +new Date() / 1000 > auth.exp;

    // if (expired) {
    //   localStorage.removeItem("good-user");
    //   localStorage.removeItem("good-auth");
    // }

    // if (auth.token && !expired) {
    //   config.headers["Authorization"] = auth.token;
    // }
    return config;
  },
  (error) => Promise.reject(error)
);

// 响应拦截器
http.interceptors.response.use(
  (response) => {
    // console.log(response, "response");
    // cancelRequest.removePendingRequest(response.config); // 从pendingRequest对象中移除请求
    return Promise.resolve(response.data);
  },
  (error) => {
    // api path 白名单 不触发退出登录
    // const whiteList = [/^\/api\/v3\/sota\/chat_sets\/.+\/mirror_deploy$/];
    const whiteList = [];
    if (error.config) {
      const { url: path } = error.config;
      // cancelRequest.removePendingRequest(error.config || {}); // 从pendingRequest对象中移除请求
      if (
        !whiteList.some((wPath: any) =>
          typeof wPath === "string" ? wPath.includes(path) : wPath.test(path)
        )
      ) {
        if (
          error.response &&
          (error.response.status === 401 || error.response.status === 422)
        ) {
          expireFn();
        }
      }
    }

    const isCancel = error.__CANCEL__;

    return Promise.reject(
      error.response
        ? { status: error.response.status, ...error.response.data }
        : isCancel
          ? { ...error, isCancel }
          : error || {}
    );
  }
);

export default http;
